export default "__VITE_ASSET__CoUKBSv9__"